export * from "./dms-patterns";
